import React from 'react';
import { useTranslation } from 'react-i18next';
import ScrollableTabs from '@medflex/components/stories/ScrollableTabs';
import { Route, Switch, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import isDesktop from '@medflex/utils/isDesktop';
import AppNotificationsSettingsModule from '../AppNotificationsSettingsModule';
import AppVersionModule from './AppVersionModule';

const AppSettingsModule = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { path } = useRouteMatch();

  const tabs = [
    ...(isDesktop()
      ? [{ key: 'appVersion', label: t('global:AppSettingsModule.tabs.appVersion') }]
      : []),
    { key: 'notifications', label: t('global:AppSettingsModule.tabs.notifications') },
  ];

  const onTabClick = tab => {
    history.push(`${path}/${tab}`);
  };

  return (
    <div data-component="AppSettingsModule" className="flex flex-1 flex-col overflow-y-auto">
      <h1 className="m-4 text-2xl font-semibold">{t('global:AppSettingsModule.title')}</h1>
      <div className="flex h-12 flex-shrink-0 bg-white">
        <ScrollableTabs
          active={location.pathname.split('/')[2]}
          onClick={tab => onTabClick(tab)}
          tabs={tabs}
          scrollable
        />
      </div>
      <div className="max-w-3xl p-4 lg:p-8">
        <Switch>
          {isDesktop() && (
            <Route exact path={`${path}/appVersion`}>
              <AppVersionModule />
            </Route>
          )}
          <Route exact path={`${path}/notifications`}>
            <AppNotificationsSettingsModule />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default AppSettingsModule;
